import React from 'react';
import Encabezado from '../components/Encabezado';
import { Card, Row, Col, Badge } from 'react-bootstrap';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserGraduate } from '@fortawesome/free-solid-svg-icons';
import dataCarreras from '../data/carreras.json';
import imagenesCarreras from '../data/imagenesCarreras';
import { obtenerEstadoCarrera, esVisible, ordenarCarreras } from '../utils/estadoCarrera';

const CarrerasPage = () => {
    const carreras = ordenarCarreras(dataCarreras.filter(esVisible));

    return (
        <div>
            <Encabezado titulo={"Oferta Académica"} />
            <section>
                <Row>
                    <Col sm={3}>
                        <div className="d-grid gap-2">
                            <Link className="btn btn-outline-primary" to="/">Volver</Link>
                        </div>
                    </Col>

                    <Col sm={9}>
                        <Row>
                            {carreras.map((carrera) => {
                                const estado = obtenerEstadoCarrera(carrera);
                                return (
                                    <Col md={6} className="mb-3" key={carrera.id}>
                                        <Card className="h-100">
                                            <Card.Img variant="top" src={imagenesCarreras[carrera.slug]} />
                                            <Badge
                                                bg=""
                                                style={{
                                                    position: 'absolute',
                                                    top: 10,
                                                    right: 10,
                                                    backgroundColor: estado.bg,
                                                    color: estado.color,
                                                    fontSize: '0.8rem',
                                                    fontWeight: 'bold',
                                                    padding: '6px 10px',
                                                    boxShadow: '0 2px 6px rgba(0,0,0,0.35)',
                                                }}
                                            >
                                                {estado.texto}
                                            </Badge>
                                            <Card.Body>
                                                <Card.Title>
                                                    <FontAwesomeIcon icon={faUserGraduate} color='#0d6efd' />
                                                    {' '}
                                                    <Link to={carrera.ruta} style={{ textDecoration: 'none' }}>
                                                        {carrera.nombre}
                                                    </Link>
                                                </Card.Title>
                                                <Card.Text>
                                                    {carrera.descripcion}
                                                </Card.Text>
                                                <Card.Text className="text-muted">
                                                    Sede: {carrera.sede}
                                                </Card.Text>
                                                <Link to={carrera.ruta} className="btn btn-outline-primary btn-sm">
                                                    PLAN DE ESTUDIOS
                                                </Link>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                );
                            })}
                        </Row>
                    </Col>
                </Row>
            </section>
        </div>
    )
}

export default CarrerasPage